import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ShippingWarehouseInventoryValueReportPage } from "src/components/views/erp/warehouse/reports/ShippingWarehouseInventoryValueReportPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/reports/shippingWarehouseInventoryValue")({
	staticData: {
		title: i18n.t("shipping_warehouse_inventory_value_report"),
		legacyViewKey: "shippingWarehouseInventoryValueReportPage",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <ShippingWarehouseInventoryValueReportPage />;
}
